import { useReportFormInfo } from 'Pages/ReportsAlerts/Reports/@hooks'
import { reportFormData, useCsv } from 'Pages/ReportsAlerts/Reports/@signals'
import { array, object } from 'yup'
import { CalendarDatePickerSeeker, DateMultiPickerSeeker, disabledBeforeToday } from '@ui-seeker/core'
import React, { useEffect } from 'react'
import { isEmpty } from '@ui-seeker/utils'
import { parseBackendDate } from '@utils'

export default function SpecificDaysField() {

	const {
		specificDates,
		setSpecificDatesInfo,
		error,
	} = useReportFormInfo(reportFormData.peek().specificDates?.map(parseBackendDate).filter(Boolean) || [], 'specificDates', object({ specificDates: array().required('Must select a rental date').min(1, 'Must select a rental date') }))

	useEffect(() => {
		return () => {
			if (!isEmpty(reportFormData.value)) setSpecificDatesInfo([], false)
		}
	}, [useCsv.value])

	return <CalendarDatePickerSeeker
		inputProps={{ sx: { backgroundColor: 'background.grey' }, readOnly: true }}
		label="Rental Dates"
		placeholder="Select a rental date"
		shouldDisableDate={disabledBeforeToday()}
		value={specificDates}
		onChange={e => setSpecificDatesInfo(e)}
		error={error}
	/>
}